import { render, staticRenderFns } from "./Redbubble.vue?vue&type=template&id=463e8e48&scoped=true&"
import script from "./Redbubble.vue?vue&type=script&lang=js&"
export * from "./Redbubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e8e48",
  null
  
)

export default component.exports